module.exports = __webpack_public_path__ + "static/media/carta_60.d4b4e74a.jpg";